import TextField from '@blueshift-ui/inputs/dist/components/text-field';
import { CLIENT_CONVERTION_ERROR_KEY } from '@nrdy-marketing-engine/cart/src/hooks/use-convert-user-to-client';
import {
  emailRules,
  firstNameRules,
  lastNameRules,
} from '@nrdy-marketing-engine/inputs/src/input-validation-rules';
import { Control, Controller, useFormState } from 'react-hook-form';
import PasswordField from '../../../../../inputs/src/password-field';
import { Client } from '../../../../@types/cart-state';
import Field from '../../shared/field';
import Title from '../../shared/title';

function CreateAccountFields({ control }: { control: Control<any> }) {
  const formState = useFormState<Client>({ control });

  return (
    <>
      <Title variant="h1">Create Account</Title>
      <Field>
        <Controller
          control={control}
          name="email"
          render={({ field: { ref, onBlur, ...field } }) => (
            <TextField
              error={!!formState.errors.email?.message}
              fullWidth
              helperText={
                formState.errors.email?.message ||
                'This email will be used for all learners on your account'
              }
              InputLabelProps={{ shrink: true }}
              label="Email"
              type="email"
              {...field}
              onBlur={() => {
                if (typeof window !== 'undefined') {
                  window.sessionStorage.removeItem(`emailError-${window.location.search}`);
                  window.sessionStorage.removeItem(CLIENT_CONVERTION_ERROR_KEY);
                }
                onBlur();
              }}
            />
          )}
          rules={emailRules}
        />
      </Field>
      <Field sx={{ marginBottom: 3 }}>
        <PasswordField
          control={control}
          error={!!formState.errors.password?.message}
          helperText={formState.errors.password?.message}
        />
      </Field>
      <Field>
        <Controller
          control={control}
          name="firstName"
          render={({ field: { ref, ...field } }) => (
            <TextField
              error={!!formState.errors.firstName?.message}
              fullWidth
              helperText={formState.errors.firstName?.message}
              InputLabelProps={{ shrink: true }}
              label="First name"
              {...field}
            />
          )}
          rules={firstNameRules}
        />
      </Field>
      <Field>
        <Controller
          control={control}
          name="lastName"
          render={({ field: { ref, ...field } }) => (
            <TextField
              error={!!formState.errors.lastName?.message}
              fullWidth
              helperText={formState.errors.lastName?.message}
              InputLabelProps={{ shrink: true }}
              label="Last name"
              {...field}
            />
          )}
          rules={lastNameRules}
        />
      </Field>
    </>
  );
}

export default CreateAccountFields;
